module.exports = __webpack_public_path__ + "static/img/ScancodeloginPersonal_phone.a02fc81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ScancodeloginPersonal_phone.png
// module id = BOCQ
// module chunks = 3